"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var config = {
    forms: {
        contact: {
            selectOptionsSubject: [
                { displayName: 'form.type.subject.option.articleError', value: 'articleError' },
                { displayName: 'form.type.subject.option.changed.email', value: 'emailChanged' },
                { displayName: 'form.type.subject.option.changed.data', value: 'dataChanged' },
                { displayName: 'form.type.subject.option.account', value: 'account' },
                { displayName: 'form.type.subject.option.retoure', value: 'retoure' },
                { displayName: 'form.type.subject.option.product', value: 'product' },
                { displayName: 'form.type.subject.option.delivery', value: 'delivery' },
                { displayName: 'form.type.subject.option.web', value: 'web' },
                { displayName: 'form.type.subject.option.complaint.comment', value: 'complaint' },
                { displayName: 'form.type.subject.option.return.data', value: 'return' },
                { displayName: 'form.type.subject.option.coupons', value: 'coupons' },
                { displayName: 'form.type.subject.option.newsletter', value: 'newsletter' },
                { displayName: 'form.type.subject.option.other', value: 'other' },
            ],
        },
    },
};
exports.default = config;
//# sourceMappingURL=universalat.js.map